/** InsCoder WANG.J 2026-09-09 B + PDP Leather Colour selector: single-selection highlight **/
(function () {
  const OPTION_SELECTOR = '[data-leather-colour-option]';
  const GROUP_SELECTOR = '.variant-picker__option-values';

  // The snippet can be rendered more than once per page, so the delegated
  // listeners must be registered only once. The flag lives on <html> to avoid
  // adding anything to the global scope.
  const root = document.documentElement;
  if (root.dataset.leatherColourInit === 'true') return;
  root.dataset.leatherColourInit = 'true';

  /** Replace a button label and keep the theme hover animation duplicates in sync. */
  const setButtonLabel = (content, label) => {
    content.textContent = label;
    ['rotated-text', 'up-text'].forEach((attribute) => {
      if (content.hasAttribute(attribute)) content.setAttribute(attribute, label);
    });
  };

  /**
   * Mirror the selected add-on availability onto the product form button. A button
   * that the server rendered as disabled already describes a main product that is
   * sold out, so its existing "Sold out" label and disabled state are preserved.
   */
  const syncBuyButton = (option) => {
    const fieldset = option.closest('fieldset');
    const button = fieldset?.closest('.shopify-section')?.querySelector('buy-buttons button[type="submit"]');
    const content = button?.querySelector('button-content');
    if (!button || !content) return;

    if (button.dataset.leatherInit !== 'true') {
      button.dataset.leatherInit = 'true';
      button.dataset.leatherLabel = content.textContent.trim();
      button.dataset.leatherEnabled = button.disabled ? '0' : '1';
    }

    const outOfStock =
      button.dataset.leatherEnabled === '1' &&
      !!option.dataset.leatherVariantId &&
      option.dataset.leatherVariantAvailable === 'false';

    /** InsCoder WANG.J 2026-09-30 B + PDP Leather Colour: sync sold-out button label and class **/
    button.disabled = outOfStock || button.dataset.leatherEnabled === '0';
    button.classList.toggle('btn--sold', button.disabled);
    setButtonLabel(content, outOfStock ? fieldset.dataset.leatherSoldOutLabel : button.dataset.leatherLabel);
    /** InsCoder WANG.J 2026-09-30 E + PDP Leather Colour: sync sold-out button label and class **/
  };

  /** InsCoder WANG.J 2026-09-29 B + PDP Leather Colour: add the add-on price on top of the rendered prices **/
  // The theme renders every price itself (sale price, compare-at price, currency
  // settings...), so the add-on is summed on top of the amounts that are already
  // in the DOM. The money format is mirrored from the shop settings so that the
  // total is rendered exactly like the server-rendered prices.
  const moneyFormat = () => {
    const settings = window.themeVariables?.settings || {};
    const format = settings.currencyCodeEnabled ? settings.moneyWithCurrencyFormat : settings.moneyFormat;
    return format || '{{amount}}';
  };

  const moneySeparators = (format) => {
    if (format.includes('comma_separator')) return { thousands: '.', decimal: ',' };
    if (format.includes('apostrophe_separator')) return { thousands: "'", decimal: '.' };
    if (format.includes('space_separator')) return { thousands: ' ', decimal: '.' };
    return { thousands: ',', decimal: '.' };
  };

  /** Render an amount in cents the same way the theme's money filter does. */
  const formatMoney = (cents, format) => {
    const placeholder = format.match(/\{\{\s*(\w+)\s*\}\}/);
    const separators = moneySeparators(format);
    const parts = (cents / 100).toFixed(placeholder?.[1]?.includes('no_decimals') ? 0 : 2).split('.');
    const units = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, separators.thousands);
    const value = parts[1] ? `${units}${separators.decimal}${parts[1]}` : units;

    return placeholder ? format.replace(placeholder[0], value) : value;
  };

  /** Read the amount in cents out of an already rendered price element. */
  const readAmount = (priceElement, format) => {
    const clone = priceElement.cloneNode(true);
    clone.querySelectorAll('.sr-only').forEach((node) => node.remove());

    const separators = moneySeparators(format);
    let text = clone.textContent.split(separators.thousands).join('');
    if (separators.decimal !== '.') text = text.split(separators.decimal).join('.');

    const match = text.match(/-?\d+(?:\.\d+)?/);
    return match ? Math.round(parseFloat(match[0]) * 100) : 0;
  };

  /**
   * Sum the selected add-on on top of the prices rendered by the theme. The base
   * amount is cached on the element so that re-applying (for instance after the
   * theme re-rendered the block) never stacks the add-on twice.
   */
  const applyAddonPrice = (option) => {
    const section = option.closest('.shopify-section');
    if (!section) return;

    // An option without a linked variant cannot be added to the cart, so it must
    // not be summed either (this also restores the price when switching back).
    const addonCents = Number(option.dataset.leatherVariantPrice || 0);

    const format = moneyFormat();
    const priceLists = section.querySelectorAll('[data-block-type="price"] .price-list, product-sticky-add-to-cart .price-list');

    priceLists.forEach((priceList) => {
      priceList.querySelectorAll('sale-price, compare-at-price').forEach((priceElement) => {
        if (priceElement.dataset.leatherBasePrice === undefined) {
          priceElement.dataset.leatherBasePrice = String(readAmount(priceElement, format));
        }

        const label = priceElement.querySelector('.sr-only');
        const total = Number(priceElement.dataset.leatherBasePrice) + addonCents;
        priceElement.innerHTML = `${label ? label.outerHTML : ''} ${formatMoney(total, format).replace('.00', '')}`;
      });
    });
  };
  /** InsCoder WANG.J 2026-09-29 E + PDP Leather Colour: add the add-on price on top of the rendered prices **/

  const selectOption = (option) => {
    const group = option.closest(GROUP_SELECTOR) || document;

    group.querySelectorAll(OPTION_SELECTOR).forEach((candidate) => {
      const selected = candidate === option;
      candidate.classList.toggle('is-selected', selected);
      candidate.setAttribute('aria-checked', selected ? 'true' : 'false');
    });

    // Keep the "Leather Colour: <name>" heading in sync with the highlight.
    // That heading is aria-hidden, so it is purely visual.
    const heading = option.closest('fieldset')?.querySelector('.text-option-value-selected-title');
    if (heading) heading.textContent = option.dataset.leatherColourName || '';

    syncBuyButton(option);
    applyAddonPrice(option);
  };

  document.addEventListener('click', (event) => {
    const option = event.target.closest?.(OPTION_SELECTOR);
    if (!option) return;

    selectOption(option);
    // Safari does not focus non-form controls on click, which would leave the
    // focus ring out of sync with the highlight.
    option.focus({ preventScroll: true });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;

    const option = event.target.closest?.(OPTION_SELECTOR);
    if (!option) return;

    event.preventDefault();
    selectOption(option);
  });

  /** Apply the current selection on load and after every native variant re-render. */
  const syncSelectedOption = () => {
    const option = document.querySelector(`${OPTION_SELECTOR}.is-selected`);
    if (!option) return;

    syncBuyButton(option);
    // The theme re-renders the price block on each variant change, so the summed
    // price has to be applied again once the new prices are in the DOM.
    applyAddonPrice(option);
  };

  syncSelectedOption();
  document.addEventListener('variant:change', syncSelectedOption);

  /**
   * Append a hidden control to the form so that the theme's own product form
   * submits it as part of its FormData.
   */
  const appendHidden = (form, name, value) => {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = String(value);
    form.append(input);
    return input;
  };

  /** InsCoder WANG.J 2026-09-29 B + PDP Leather Colour: add the selected add-on to the cart **/
  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || !form.action.includes('/cart/add')) return;
      if (!form.closest('product-form')) return;

      const option = form.closest('.shopify-section')?.querySelector(`${OPTION_SELECTOR}.is-selected`);
      const addonId = Number(option?.dataset.leatherVariantId || 0);
      const mainIdInput = form.querySelector('[name="id"]');
      if (!addonId || !mainIdInput) return;

      // The theme builds its FormData from the form and skips disabled controls, so
      // the original payload is parked while the equivalent items[] payload (main
      // product + leather colour add-on) is submitted in its place.
      // The theme's quantity input lives outside the form and is associated
      // through its form="" attribute, so it is only reachable via form.elements.
      const quantityInput = Array.from(form.elements).find((element) => element.name === 'quantity');
      const quantity = Math.max(1, parseInt(quantityInput?.value || '1', 10) || 1);
      const mainId = mainIdInput.value;
      mainIdInput.disabled = true;
      if (quantityInput) quantityInput.disabled = true;

      const injected = [
        appendHidden(form, 'items[0][id]', mainId),
        appendHidden(form, 'items[0][quantity]', quantity),
        appendHidden(form, 'items[1][id]', addonId),
        appendHidden(form, 'items[1][quantity]', 1),
      ];

      // A microtask is drained as soon as this listener returns, which is before
      // the form's own submit listener reads the form data, so the cleanup has to
      // wait for the next task. The theme builds its FormData synchronously in the
      // same task, which guarantees it sees the injected controls.
      setTimeout(() => {
        injected.forEach((input) => input.remove());
        mainIdInput.disabled = false;
        if (quantityInput) quantityInput.disabled = false;
      }, 0);
    },
    true,
  );
  /** InsCoder WANG.J 2026-09-29 E + PDP Leather Colour: add the selected add-on to the cart **/
})();
/** InsCoder WANG.J 2026-09-09 E + PDP Leather Colour selector: single-selection highlight **/
